export { dialogContentPropDefs as alertDialogContentPropDefs } from './dialog.props.js';
export type { DialogContentOwnProps as AlertDialogContentOwnProps } from './dialog.props.js';
